import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getLogisticRoutesGeoZones(companyId, logisticRouteId) {
	return dataTransferWrap(
		ModulesMap.LOGISTIC_ROUTES_GEO_ZONES,
		dtConfig[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].getLogisticRoutesGeoZones,
		{
			urlParams: {
				companyId,
				logisticRouteId,
			},
		}
	)
}

function getLogisticRoutesGeoZonePreview(companyId, logisticRouteId, geoZoneId) {
	return dataTransferWrap(
		ModulesMap.LOGISTIC_ROUTES_GEO_ZONES,
		dtConfig[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].getLogisticRoutesGeoZonePreview,
		{
			urlParams: {
				companyId,
				logisticRouteId,
                geoZoneId,
			},
		}
	)
}

function getLogisticRoutesGeoZonePopup(companyId, logisticRouteId, geoZoneId) {
	return dataTransferWrap(
		ModulesMap.LOGISTIC_ROUTES_GEO_ZONES,
		dtConfig[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].getLogisticRoutesGeoZonePopup,
		{
			urlParams: {
				companyId,
				logisticRouteId,
                geoZoneId,
			},
		}
	)
}

function getLogisticRoutesGeoZone(companyId, logisticRouteId, geoZoneId) {
	return dataTransferWrap(
		ModulesMap.LOGISTIC_ROUTES_GEO_ZONES,
		dtConfig[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].getLogisticRoutesGeoZone,
		{
			urlParams: {
				companyId,
				logisticRouteId,
                geoZoneId,
			},
		}
	)
}

function createLogisticRoutesGeoZone(companyId, logisticRouteId, data) {
	return dataTransferWrap(
		ModulesMap.LOGISTIC_ROUTES_GEO_ZONES,
		dtConfig[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].createLogisticRoutesGeoZone,
		{
			urlParams: {
				companyId,
                logisticRouteId,
			},
			...data,
		}
	)
}

function putLogisticRoutesGeoZone(companyId, logisticRouteId, geoZoneId, data) {
	return dataTransferWrap(
		ModulesMap.LOGISTIC_ROUTES_GEO_ZONES,
		dtConfig[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].putLogisticRoutesGeoZone,
		{
			urlParams: {
				companyId,
				logisticRouteId,
                geoZoneId,
			},
			...data,
		}
	)
}

function patchLogisticRoutesGeoZone(companyId, logisticRouteId, geoZoneId, data) {
	return dataTransferWrap(
		ModulesMap.LOGISTIC_ROUTES_GEO_ZONES,
		dtConfig[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].patchLogisticRoutesGeoZone,
		{
			urlParams: {
				companyId,
				logisticRouteId,
                geoZoneId,
			},
			...data,
		}
	)
}

function deleteLogisticRoutesGeoZone(companyId, logisticRouteId, geoZoneId) {
	return dataTransferWrap(
		ModulesMap.LOGISTIC_ROUTES_GEO_ZONES,
		dtConfig[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].deleteLogisticRoutesGeoZone,
		{
			urlParams: {
				companyId,
				logisticRouteId,
                geoZoneId,
			},
		}
	)
}

export default {
	getLogisticRoutesGeoZones,
	getLogisticRoutesGeoZonePreview,
	getLogisticRoutesGeoZonePopup,
	getLogisticRoutesGeoZone,
	createLogisticRoutesGeoZone,
	putLogisticRoutesGeoZone,
	patchLogisticRoutesGeoZone,
	deleteLogisticRoutesGeoZone,
}
